import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
//import { MDBBootstrapModule } from "angular-bootstrap-md";
import { TranslatePipe } from './pipes/translate.pipe'
import { RouterModule } from "@angular/router";
import { InsertionDirective } from './directives/insertion-directive';

import { TruncatePipe } from './pipes/truncate.pipe';
import { BytesPipe } from './pipes/bytes.pipe';
import { FileUploadInputForDirective } from './directives/file-upload-input-for.directive';
import { DndDirective } from './directives/dnd.directive';
import { HeaderGroupComponent } from './ag-grid/header-group/header-group.component';
import { SquirrelLargeScreenDirective } from './directives/squirrel-large-screen.directive';
import { SquirrelSmallScreenDirective } from './directives/squirrel-small-screen.directive';
import { SquirrelCellLoaderRendererComponent } from './squirrel-cell-loader-renderer/squirrel-cell-loader-renderer.component';
import { AutofocusDirective } from './directives/autofocus.directive';


@NgModule({
  declarations: [TranslatePipe, InsertionDirective, TruncatePipe, BytesPipe, FileUploadInputForDirective, DndDirective, 
    HeaderGroupComponent, SquirrelLargeScreenDirective, SquirrelSmallScreenDirective, SquirrelCellLoaderRendererComponent, AutofocusDirective],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    // FormlyModule,
    // FormlyMaterialModule,
    //NgChartsModule,
    FormsModule,
    RouterModule,
    
  ],
  exports: [
    ReactiveFormsModule, FormsModule, TranslatePipe, TruncatePipe, RouterModule, SquirrelLargeScreenDirective, SquirrelSmallScreenDirective,
    // FormlyModule,
    // FormlyMaterialModule,
    // FormlyMatSelectModule,
    // FlexLayoutModule
    FileUploadInputForDirective,
    SquirrelCellLoaderRendererComponent
    ],
  providers: []
})
export class SharedModule { }
